"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragTypes = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var DragTypes = (0, _keyMirror.default)({
  FORM_FIELD: null,
  CONTACT_PROPERTY_OPTION_SORT: null
});
exports.DragTypes = DragTypes;